var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { Entity, Type } from '@decahedron/entity';
import { Role } from 'packages/user_groups/Role';
export var DEFAULT_USER_GROUPS = [
    'admin',
    'content_manager',
    'recruitment_manager',
];
var UserGroup = /** @class */ (function (_super) {
    __extends(UserGroup, _super);
    function UserGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.companyId = null;
        _this.name = null;
        _this.allowed = null;
        _this.roles = [];
        _this.objectWideAccess = null;
        _this.job = null;
        return _this;
    }
    UserGroup.prototype.hasUserId = function (userId) {
        return this.roles.some(function (role) { return role.users.some(function (user) { return user.id === userId; }); });
    };
    Object.defineProperty(UserGroup.prototype, "users", {
        get: function () {
            var users = [];
            this.roles.forEach(function (role) {
                users = __spreadArray(__spreadArray([], role.users), users).map(function (item) {
                    if (item.role) {
                        return item;
                    }
                    item.role = role.name;
                    return item;
                });
            });
            return users;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserGroup.prototype, "isDefaultGroup", {
        get: function () {
            return DEFAULT_USER_GROUPS.includes(this.name);
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Type(Role),
        __metadata("design:type", Array)
    ], UserGroup.prototype, "roles", void 0);
    return UserGroup;
}(Entity));
export { UserGroup };
